__turbopack_context__.v({
  "horizontalSeparator": "HorizontalSeparator-module__b2wBcq__horizontalSeparator",
  "horizontalSeparatorAccent": "HorizontalSeparator-module__b2wBcq__horizontalSeparatorAccent",
  "horizontalSeparatorInverted": "HorizontalSeparator-module__b2wBcq__horizontalSeparatorInverted",
  "horizontalSeparatorLight": "HorizontalSeparator-module__b2wBcq__horizontalSeparatorLight",
  "horizontalSeparatorRegular": "HorizontalSeparator-module__b2wBcq__horizontalSeparatorRegular",
});
